<template>
  <el-dialog :visible.sync="dialogVisible" width="600px" title="嘉宾设置" @close="close" @open="InitGuestsList()">
    <div class="guests-list">
      <ul v-loading="guestsLoading">
        <li v-for="(item,index) in guestsListData" :key="index">
          <div class="item-info">
            <img class="guests-avatar" :src="item.head_img" alt />
            <el-input type="text" v-model="item.guest_name" size="mini" class="guests-name vm"></el-input>
            <el-select class="guests-job vm"
             v-model="item.type" 
             placeholder="请选择身份"
             size="mini">
              <el-option
                v-for="item in options.job"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <el-button type="primary" size="mini" @click="removeUser(index)">移除</el-button>
        </li>
      </ul>
      <div class="prompt_info" v-if="(guestsListData.length==0)&&guestsListData">
        <p class="tc">暂无嘉宾，请添加</p>
      </div>
    </div>
    <div class="search-wrap">
      <el-input v-model="searchName" placeholder="请输入要搜索的用户">
        <el-button slot="append" icon="el-icon-search" @click="getUserList()"></el-button>
      </el-input>
      <div class="search-list">
        <ul v-loading="userLoading">
          <li class="flex-between" v-for="(item,index) in userListData.list" :key="index">
            <div class="item-left">
              <img class="guests-avatar" :src="item.user_pfrofile_photo" alt />
              <span class="guests-name">{{item.wechat_nick_name}}</span>
            </div>
            <el-button
              type="primary"
              icon="el-icon-plus"
              circle
              size="mini"
              @click="addUser(item,index)"
            ></el-button>
          </li>
        </ul>
      </div>
    </div>
    <div slot="footer" class="tc">
      <el-button @click="invite">邀请微信好友</el-button>
      <el-button type="primary" @click="submitGuestInfo()" :disabled="guestsListData.length>0?false:true">确 定</el-button>
    </div>

    <el-dialog width="300px" title="邀请二维码" :visible.sync="innerVisible" append-to-body>
      <div class="tc">
        <img width="150" height="150" src="../../../assets/logo.png" alt />
        <p style="margin-top: 20px;">微信扫码分享给好友</p>
      </div>
    </el-dialog>
  </el-dialog>
</template>


<script>
import { _guestsList, _guestAdd } from "@/api/guest-setting.js";

import { _userList } from "@/api/user.js";

import qs from 'qs';

export default {
  props: {
    addCourseVisible: {
      type: Boolean,
      default: false
    },
    btn_text: {
      type: String,
      default: "新建课程"
    },
    btn_path: {
      type: String,
      default: "/course/liveadd"
    },
    course_id: {
    }
  },
  data() {
    return {
      guestsLoading:false,
      userLoading:false,
      dialogVisible: false,
      innerVisible: false,
      searchName: "",
      guestsListData: [
      ],
      userListData: [
      ],
      options: {
        job: [
          {
            label: "讲师",
            value: "2"
          },
          {
            label: "主持人",
            value: "1"
          }
        ]
      }
    };
  },
  created() {
      this.InitUserList();
  },
  methods: {
    //关闭的时候改变父组件传来的状态
    close() {
      this.guestsListData=[];
      this.$emit("update:addCourseVisible", false);
    },
    //查询相关的用户信息
    getUserList(){
      this.InitUserList();
    },
    //获取嘉宾列表
    InitGuestsList() {
      this.guestsLoading=true;
      _guestsList({
        params: {
          course_id: this.course_id
        }
      }).then(res => {
      this.guestsLoading=false;
        //console.log(res);
        if(res.resultCode==1){
          res.result.map(item=>{
            item.course_id=this.course_id
            item.type+='';
          })
          this.guestsListData=res.result;
          // console.log(this.guestsListData);
        }else{
          this.$message.error(res.errorMsg);
        }
      });
    },
    //获取用户的列表
    InitUserList() {
      this.userLoading=true;
      _userList({
        params: {
          page:1,
          size:10,
          keywords:this.searchName
        }
      }).then(res => {
        // console.log(res);
        this.userLoading=false;
        if(res.resultCode==1){
          this.userListData=res.result;
        }else{
          this.$message.error(res.errorMsg);
        }
      });
    },
    //提交添加或者删除的信息
    submitGuestInfo(){
      let data=this.guestsListData;
      // if(data.length==0)
      _guestAdd({
        data:qs.stringify({guests:data})
      }).then((res)=>{
        if(res.resultCode==1){
          this.$emit('uploadStatus',true);
          this.$message.success(res.errorMsg);
          this.dialogVisible = false;
          this.close();
        }else{
          this.$message.error(res.errorMsg);
        }
      })
    },
    selectionChange(val) {
      this.listSelectionList = val.map(_ => _.id);
    },
    invite() {
      this.innerVisible = true;
    },
    submit() {
      // //console.log(this.guestsList);
      // this.$emit("submitData", this.listSelectionList);
      //改变弹框得状态
      this.dialogVisible = false;
      this.close();
    },
    //添加用户
    addUser(item, index) {
      //添加循环判断不允许重复添加，如果更改了名字但是id还是原来的的id。还是不允许添加
      let is_repeat = "";
      if (this.guestsListData.length > 0) {
        is_repeat = this.guestsListData.filter((info, i) => {
          return info.user_id == item.user_id || info.wechat_nick_name == item.wechat_nick_name;
        });
      }
      // //console.log(is_repeat.length);
      if (is_repeat.length > 0) {
        this.$message.error("不可以重复添加相同嘉宾");
      } else {
        this.guestsListData.push({
          course_id:this.course_id,
          user_id:item.user_id,
          guest_name: item.wechat_nick_name,
          type: '1',
          head_img:item.user_pfrofile_photo
        });
      }
      //console.log(this.guestsListData);
    },
    //移除讲师或者是主持人
    removeUser(index) {
      this.guestsListData.splice(index, 1);
    }
  },
  watch: {
    //监听父组件传来的值的变化（弹框的变化）
    addCourseVisible(newVal) {
      this.dialogVisible = newVal;
    },
    course_id(newVal) {
        // this.InitGuestsList();
    },
  }
};
</script>

<style lang="less" scoped>
.guests-list {
  border-bottom: 1px solid @border-color;
  .prompt_info{
    height: 50px;
    width: 100%;
    font-size: 20px;
  }
}

.search-list,
.guests-list {
  max-height: 200px;
  overflow-y: auto;
  li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
  }
  .item-info {
  }
}

.guests-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
}

.guests-name {
  display: inline-block;
  width: 140px;
  margin-left: 10px;
  margin-right: 20px;
}

.search-wrap {
  margin-top: 20px;
}
</style>
